/**
* Hero with Carousel JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero with Carousel component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'hero-with-carousel',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.hero-with-carousel__splide' ).length ) {
        $( '.hero-with-carousel__splide' ).each( function( index, element ) {
          new Splide( element, {
            type: 'fade',
            rewind: true,
            perMove: 1,
            pagination: true,
            breakpoints: {
              1024: {
                pagination: false,
              },
            },
          } ).mount( );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-with-carousel', COMPONENT );
} )( app );
